import _ = require("lodash");
import * as path from "path-browser";
import Loader from "./loader";

const manifest = require("../../../content-manifest.json");

export default async function loadDependencies(config): Promise<string> {
    let launcherDependencies = [];
    let frameworkDependencies = [];

    // gather launcher dependencies
    const escapedID = config.contentTypeID.replace(`${config.libPrefix}.`, "");
    let modules: any = _.get(manifest[config.libPrefix],
        `${escapedID}.modules`);
    if (!modules) {
        console.warn(`Entry for given contentId ${config.contentTypeID} not found in content-manifest.json.
        Using default module ${config.manifest.modules}`);
        modules = config.manifest.modules;
    }

    modules.forEach(async fileName => {
        launcherDependencies = _.union(launcherDependencies, manifest.launcherDependencies[fileName]);
    });
    launcherDependencies = _.union(launcherDependencies, modules);

    // gather framework dependencies
    launcherDependencies.forEach((launcherDependency) => {
        frameworkDependencies =
            _.union(frameworkDependencies, manifest.frameworkDependencies[launcherDependency]);
    });

    // generate path for framework dependencies
    const fileGroups: any[] = [];
    const frameworkFilePaths: any = frameworkDependencies.map((frameworkDependency) => {
        return path.join(config.paths.frameworks, frameworkDependency);
    });
    fileGroups.push(groupFilePathsForLoadingSequence(frameworkFilePaths));

    // generate path for launcher dependencies
    const launcherFilePaths = launcherDependencies.map((launcherDependency) => {
        return path.join(config.paths.launcher, launcherDependency + ".js");
    });
    fileGroups.push(groupFilePathsForLoadingSequence(launcherFilePaths));

    // load all files
    for (const fileGroup of fileGroups) {
        const promises: any[] = [];
        for (const filePaths of fileGroup) {
            promises.push(Loader.load(filePaths));
        }
        await Promise.all(promises);
    }
    return launcherDependencies[launcherDependencies.length - 1];
}

function groupFilePathsForLoadingSequence(filePaths: string[]): any[] {
    const finalPathGroups = _.values(
        _.groupBy(filePaths, path => path.split("/")[1])
    );
    return finalPathGroups;
}
